import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import globals from '../../../globals/communityGlobals';
import { capitalFirstLetter } from '../../../utils/helpers';

const TODAY = globals.now;

class Calendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentMonth: moment(this.props.selectedDate),
    };
    this.styles = {
      current: { borderColor: '#4dc3f9' },
      selected: { backgroundColor: '#4dc3f9' },
    };
  }
  componentWillReceiveProps(nextProps) {
    if (!moment(this.props.selectedDate).isSame(nextProps.selectedDate, 'month')) {
      this.setState({
        currentMonth: moment(nextProps.selectedDate),
      });
    }
  }

  nextMonth = () => {
    this.setState({
      currentMonth: this.state.currentMonth.add(1, 'month'),
    });
  };

  previousMonth = () => {
    this.setState({
      currentMonth: this.state.currentMonth.subtract(1, 'month'),
    });
  };

  pickDate = e => {
    this.props.changeDate(e.target.dataset.date);
  };

  renderDays = month => {
    const iteratorDate = moment(month).startOf('month');
    const offset = iteratorDate.day() - 1 < 0 ? 6 : iteratorDate.day() - 1;

    iteratorDate.subtract(offset + 1, 'days');
    const days = [];
    for (let i = 0; i < 42; i += 1) {
      iteratorDate.add(1, 'day');
      const isToday = iteratorDate.isSame(TODAY, 'day');
      const isInCurrentMonth = iteratorDate.isSame(month, 'month');
      const isSelected = iteratorDate.isSame(this.props.selectedDate, 'day');

      days.push(
        <div key={`calendarDayInstance${i}`} className={`day${!isInCurrentMonth ? ' non-current' : ''}`}>
          {isToday && <div className="current" style={this.styles.current} />}
          {isSelected && <div className="selected" style={this.styles.selected} />}
          <button data-date={iteratorDate.format(globals.dateFormats.date)} onClick={this.pickDate}>
            {iteratorDate.date()}
          </button>
        </div>,
      );
    }
    return days;
  };

  render() {
    const currentMonth = this.state.currentMonth;
    const daysHeader = globals.weekdayNames.map(el => (
      <p key={`calendarDaysHeader${el}`} className="day-headers noselect">
        {el}
      </p>
    ));
    const daysShown = this.renderDays(currentMonth);
    const monthDisplayName = capitalFirstLetter(currentMonth.format('MMMM'));

    return (
      <div id="careSchedulerCalendar">
        <div className="flex-col">
          <div className="padding">
            <div className="month">
              <button className="month-arrow left" alt="back" onClick={this.previousMonth} />
              <p className="month-title">
                {monthDisplayName}
                <br />
                <span className="month-year">{currentMonth.format('YYYY')}</span>
              </p>
              <button className="month-arrow right" alt="forward" onClick={this.nextMonth} />
            </div>
            <div className="calendar-content">
              {daysHeader}
              <div className="daysContainer">{daysShown}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Calendar.propTypes = {
  changeDate: PropTypes.func,
  selectedDate: PropTypes.string.isRequired,
};

Calendar.defaultProps = {
  changeDate: () => {},
};

export default Calendar;
